export class AnswerExtractor {
  static extractAnswer(questionType: string): string | string[] | null {
    switch (questionType) {
      case 'radio':
      case 'select':
        return this.getRadioValue();
      case 'checkbox':
        return this.getCheckboxValues();
      case 'grid':
        return this.getGridValue();
      case 'dropdown':
      case 'text':
      case 'textarea':
      case 'email':
      case 'rating':
      case 'date':
      case 'time':
        return this.getInputValue();
      default:
        return this.getInputValue();
    }
  }

  private static getRadioValue(): string | null {
    const selected = document.querySelector<HTMLInputElement>('input[name="answer"]:checked');
    return selected?.value || null;
  }

  private static getCheckboxValues(): string[] {
    const selected = document.querySelectorAll<HTMLInputElement>('input[name="answer"]:checked');
    return Array.from(selected).map(input => input.value);
  }

  private static getInputValue(): string | null {
    const input = document.querySelector<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>('#answer');
    return input?.value || null;
  }

  private static getGridValue(): string | null {
    const hiddenInput = document.querySelector<HTMLInputElement>('#answer');
    const value = hiddenInput?.value;

    // Return null if empty object or no value
    if (!value || value === '{}') {
      return null;
    }

    return value;
  }
}
